export default __webpack_public_path__ + "static/media/007-clown.ebb85fd0.svg";